// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__v-2xh","icon":"CloseButton_icon__0Zu0U"};